import React, { Component } from 'react';

export default class ShowMediaRollover extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isRolloverVisible: false,
        };

        this.toggleRollover = this.toggleRollover.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.rolloverRef && !this.rolloverRef.contains(event.target)) {
            this.setState({ isRolloverVisible: false });
        }
    }

    toggleRollover(e) {
        e.stopPropagation();
        this.setState((prevState) => ({
            isRolloverVisible: !prevState.isRolloverVisible,
        }));
    }

    render() {
        return (
            <div className="rollover-container" style={{ position: 'relative', display: 'inline-block' }}>
                <button
                    className="btn btn-link btn-info"
                    style={{ fontSize: 'medium' }}
                    onClick={this.toggleRollover}
                    title="View Images"
                >
                    <i className="far fa-image"></i>
                </button>

                {this.state.isRolloverVisible && (
                    <div
                        className="rollover-panel"
                        ref={(el) => (this.rolloverRef = el)}
                        style={{
                            position: 'fixed',
                            backgroundColor: '#fff',
                            border: '1px solid #ccc',
                            padding: '20px',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                            zIndex: 1000,
                            width: '500px',
                            height: '400px',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            overflowY: 'auto',
                        }}
                    >
                        {this.props.jobMedia && this.props.jobMedia.length > 0 ? (
                            <div
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    position: 'relative',
                                }}
                            >
                                {this.props.jobMedia.slice(0, 4).map((media, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            position: 'absolute',
                                            width: '50%',
                                            height: '50%',
                                            ...(index === 0 && {
                                                top: 0,
                                                left: 0,
                                            }),
                                            ...(index === 1 && {
                                                top: 0,
                                                right: 0,
                                            }),
                                            ...(index === 2 && {
                                                bottom: 0,
                                                right: 0,
                                            }),
                                            ...(index === 3 && {
                                                bottom: 0,
                                                left: 0,
                                            }),
                                        }}
                                    >
                                        <img
                                            src={media.url}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                            }}
                                            alt=""
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p>No media available.</p>
                        )}
                    </div>
                )}
            </div>
        );
    }
}
